import React from "react";
import {
  ScatterChart, Scatter, XAxis, YAxis, ZAxis, ReferenceLine, ResponsiveContainer, Tooltip, Cell,
} from "recharts";
import { classColor } from "@/lib/format";

// Suppliers plotted on Value (x, SPI) vs Risk (y). 4 quadrants.
export function SupplierQuadrant({ data, onSelect }) {
  if (!data) return null;
  const points = data.map((d) => ({ ...d, x: d.value, y: d.risk }));

  return (
    <div className="w-full" data-testid="supplier-quadrant">
      <div className="relative" style={{ height: 320 }}>
        <div className="absolute top-1 left-2 eyebrow" style={{ color: "#E63946" }}>High Risk</div>
        <div className="absolute bottom-8 left-2 eyebrow" style={{ color: "#33b76d" }}>Low Risk</div>
        <div className="absolute bottom-1 left-2 eyebrow">Low Value</div>
        <div className="absolute bottom-1 right-2 eyebrow" style={{ color: "#33b76d" }}>High Value</div>
        <ResponsiveContainer width="100%" height="100%">
          <ScatterChart margin={{ top: 24, right: 24, bottom: 24, left: 8 }}>
            <XAxis type="number" dataKey="x" domain={[30, 100]} name="Value (SPI)"
              tick={{ fill: "#8BA1C0", fontSize: 10, fontFamily: "JetBrains Mono" }}
              stroke="#1c2c4d" axisLine={{ stroke: "#1c2c4d" }} label={{ value: "VALUE (SPI) →", position: "insideBottom", offset: -8, fill: "#8BA1C0", fontSize: 10 }} />
            <YAxis type="number" dataKey="y" domain={[0, 50]} name="Risk" reversed
              tick={{ fill: "#8BA1C0", fontSize: 10, fontFamily: "JetBrains Mono" }} />
            <ZAxis range={[260, 260]} />
            <ReferenceLine x={70} stroke="#8BA1C0" strokeDasharray="4 4" opacity={0.4} />
            <ReferenceLine y={25} stroke="#8BA1C0" strokeDasharray="4 4" opacity={0.4} />
            <Tooltip
              cursor={{ strokeDasharray: "3 3", stroke: "#33b76d" }}
              contentStyle={{ background: "#0A1224", border: "1px solid rgba(139,161,192,0.3)", borderRadius: 0, fontFamily: "JetBrains Mono", fontSize: 12 }}
              labelStyle={{ color: "#fff" }}
              formatter={(v, n, p) => [n === "x" ? `SPI ${v}` : `Risk ${v}`, ""]}
            />
            <Scatter data={points} onClick={(e) => onSelect && onSelect(e.id)} cursor="pointer">
              {points.map((p, i) => (
                <Cell key={i} fill={classColor(p.classification)} />
              ))}
            </Scatter>
          </ScatterChart>
        </ResponsiveContainer>
        {/* labels overlay */}
      </div>
      <div className="flex flex-wrap gap-2 mt-1">
        {data.map((d) => (
          <button key={d.id} onClick={() => onSelect && onSelect(d.id)}
            data-testid={`quadrant-chip-${d.id}`}
            className="flex items-center gap-1.5 px-2 py-1 panel-2 hover:border-brand-green/50 transition-colors">
            <span className="w-2 h-2" style={{ background: classColor(d.classification) }} />
            <span className="text-[0.72rem] font-mono text-ink">{d.name}</span>
            <span className="text-[0.66rem] text-ink-soft">SPI {d.spi}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
